<template>
  <div class="">
    <v-card-title class="mb-8 pa-0">
      Dashboard Overview
    </v-card-title>
    <v-row class="pa-0">
      <v-col cols="12" md="3">
        <router-link :to="{ name:'bookings' }" tag="div" class="link-cursor">
          <v-card
            elevation="0">
            <v-list-item three-line>
              <v-list-item-avatar class="mr-1">
                <v-icon
                  large
                  color="#000000"
                >
                  mdi-truck-outline
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="today-sales-title font-weight-bold" style="color:#000000">
                  {{ formatNumber(summary.total_shipment) }}
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">Total Shipment</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </router-link>
      </v-col>

      <v-col cols="12" md="3">
        <router-link :to="{ name:'bookings', query: { status: $getConstBookingStatus('BOOKING_STATUS_PENDING') } }" tag="div" class="link-cursor">
          <v-card
            elevation="0">
            <v-list-item three-line>
              <v-list-item-avatar class="mr-1">
                <v-icon
                  large
                  color="#A3A8AD"
                >
                  mdi-cube-outline
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="today-sales-title font-weight-bold" style="color:#A3A8AD">
                  {{ formatNumber(summary.pending) }}
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">Pending Shipment</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </router-link>
      </v-col>

      <v-col cols="12" md="3">
        <router-link :to="{ name:'bookings', query: { status: $getConstBookingStatus('BOOKING_STATUS_ONGOING') } }" tag="div" class="link-cursor">
          <v-card
            elevation="0">
            <v-list-item three-line>
              <v-list-item-avatar class="mr-1">
                <v-icon
                  large
                  color="#005EB8"
                >
                  mdi-cube-send
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="today-sales-title font-weight-bold" style="color:#005EB8">
                  {{ formatNumber(summary.ongoing) }}
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">On-Going Shipment</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </router-link>
      </v-col>

      <v-col cols="12" md="3">
        <router-link :to="{ name:'bookings', query: { status: $getConstBookingStatus('BOOKING_STATUS_COMPLETED') } }" tag="div" class="link-cursor">
          <v-card
            elevation="0">
            <v-list-item three-line>
              <v-list-item-avatar class="mr-1">
                <v-icon
                  large
                  color="#4caf50"
                >
                  mdi-cube-outline
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="today-sales-title font-weight-bold" style="color:#4caf50">
                  {{ formatNumber(summary.completed) }}
                </v-list-item-title>
                <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">Completed</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">

        <v-card elevation="0" class="pa-6 pt-4 mt-4">
          <v-card-title>
            Bookings
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              class="table-search"
              append-icon="mdi-magnify"
              label="Search"
              hide-details>
            </v-text-field>
          </v-card-title>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="bookings"
            :server-items-length="pagination.total"
            :items-per-page="pagination.per_page"
            :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
            :loading="loading"
            loading-text="Loading Bookings..."
            item-key="id"
            no-data-text="No Bookings Found"
            :options.sync="options"
            ref="table">

            <template v-slot:[`item.shipping_mark`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-2">
                  {{ isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane' }}
                </v-icon>
                {{ item.shipping_mark }}
              </div>
            </template>

            <template v-slot:[`item.name`]="{ item }">
              {{ item.first_name + ' ' + item.last_name }}
            </template>

            <template v-slot:[`item.total_qty`]="{ item }">
              {{ formatNumber(item.total_qty) }}
            </template>

            <template v-slot:[`item.total_cbm`]="{ item }">
              <span v-if="isShipmentForSea(item.shipment_type)">{{formatNumber(item.total_cbm) }} CBM</span>
              <span v-if="!isShipmentForSea(item.shipment_type)">{{formatNumber(item.total_kg) }} KG</span>
            </template>

            <template v-slot:[`item.client_name`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-1">
                  mdi-account-outline
                </v-icon>
                {{ item.client_name }}
              </div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <BookingStatusLabel :status="item.status" :small="true" :statuses="statuses"></BookingStatusLabel>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | moment("MM-D-YYYY") }}
            </template>


            <template v-slot:item.action="{ item }">

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    color="primary"
                    @click="viewItem(item.id)">
                    mdi-file-document-edit-outline
                  </v-icon>
                </template>
                <span>View</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BookingStatusLabel from '@/components/BookingStatusLabel.vue'

export default {
  name: 'DashboardAgent',
  data: () => ({
    agentNamespace: 'sales-agent',
    firstLoad: true,
    loading: false,
    search: '',
    awaitingSearch: false,
    selected: [],
    statuses: [],
    bookings: [],
    agents: [],
    summary: {
      pending: 0,
      for_delivery: 0,
      completed: 0,
      ongoing: 0,
      total_shipment: 0
    },
    pagination: {
      page: 1,
      per_page: 1,
      total: 0,
      next: 0
    },
    options: {},
    headers: [
      {
        text: 'Shipping Mark',
        align: 'start',
        value: 'shipping_mark',
        sortable: false,
        width: 230
      },
      {
        text: 'Container',
        align: 'start',
        value: 'containers',
        sortable: false
      },
      {
        text: 'Description',
        align: 'start',
        value: 'details',
        sortable: false
      },
      {
        text: 'Total Qty',
        align: 'right',
        value: 'total_qty',
        sortable: false,
        width: 90
      },
      {
        text: 'Measure',
        align: 'right',
        value: 'total_cbm',
        sortable: false,
        width: 120
      },
      {
        text: 'Client Name',
        align: 'start',
        value: 'client_name',
        width: 200,
        sortable: false
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: false,
        width: 70,
      },
      {
        text: 'Action',
        value: 'action',
        align: 'center',
        sortable: false,
        width: 90
      }
    ]
  }),

  computed: {
    ...mapGetters(['formatNumberAmount', 'formatNumber', 'forSea'])
  },
  watch: {
    options: {
      handler () {
        this.getBookings()
      },
      deep: true,
    },
    search: function (val) {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.options.page = 1
          this.getBookings()
          this.awaitingSearch = false;
        }, 1000); // 1 sec delay
      }
      this.awaitingSearch = true;
    },
  },
  methods: {
    isShipmentForSea (shipment_type){
      return this.forSea(shipment_type, this)
    },
    getAgentName: function(id){
      let agents = this.agents.filter(agent => {
        return agent.id == id
      })
      if(agents.length > 0){
        let agent = agents[0]
        return agent.first_name + ' ' + agent.last_name
      }
    },
    getStatusName: function(id){
      let statuses = this.statuses.filter(status => {
        return status.id == id
      })
      if(statuses.length > 0){
        return statuses[0].name
      }
    },
    getDefaultData () {
      let self = this
      this.$http.plain.get('/default-data?booking_statuses=true&agents=true')
        .then(response => {
          this.statuses = response.data.booking_statuses
          this.agents = response.data.agents
        })
        .catch(error => {
          console.log(error);
        })
    },
    getSummary () {
      let self = this
      this.$http.plain.get(this.agentNamespace+'/bookings/summary')
        .then(response => {
          this.summary = response.data
        })
        .catch(error => {
          console.log(error);
        })
    },
    viewItem (id) {
      this.$router.push({ name: 'booking-view', params: { id: id } })
    },
    getBookings () {
      if (this.loading) {
        return false
      }

      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sorting = []
      let params = []

      if (sortBy.length === 1 && sortDesc.length === 1) {
        sortBy.forEach(function (item, index) {
          let sort = 'ASC'
          if (!sortDesc[index]) {
            sort = 'DESC'
          }
          sorting.push(item+'='+sort)
        });
      }

      if (this.search.length > 0){
        params.push('&search='+this.search)
      }

      this.loading = true
      let self = this
      this.$http.plain.get(this.agentNamespace+'/bookings?page='+ page + '&per_page=' + itemsPerPage + params.join())
        .then(response => {
          this.bookings = response.data.bookings

          if (response.data.pagination) {
            let pagination = response.data.pagination

            this.pagination.total = pagination.count
          }

        })
        .catch(error => {
          console.log(error);
        })
        .then(function () {
          self.loading = false
        })
      }
  },
  mounted () {
    this.getDefaultData()
    this.getSummary()
  },
  components: {
    BookingStatusLabel
  },
};
</script>
